
// Small, discreet DOM tooltip for 3D-space digitization controls (the
// label's copy-icon, a segment's insert-vertex "+" handle, ...) that can't
// use the browser's native `title` attribute since they're WebGL objects,
// not DOM elements. Tracks the cursor globally so callers only need to say
// *what* to show - see FeatureVisual.js's mouseover/mouseleave wiring on
// those markers for *when*.
import {ensureHudStyle} from "./HudSkin.js";
let tooltipEl = null;
let lastX = 0;
let lastY = 0;

// Guarded: this module can be pulled in transitively (e.g. a tool
// definition file imported by a Level 1/no-DOM test just to read its
// tooltip/name) outside a real browser - importing it must never crash
// there. In an actual browser, `window` always exists, so this is a no-op
// guard, not a behaviour change.
if(typeof window !== "undefined"){
	window.addEventListener("mousemove", (e) => {
		lastX = e.clientX;
		lastY = e.clientY;
	});
}

function ensureElement(){
	if(!tooltipEl){
		ensureHudStyle();
		tooltipEl = document.createElement("div");
		tooltipEl.className = "pvh pvh--tooltip";
		tooltipEl.style.display = "none";
		document.body.appendChild(tooltipEl);
	}

	return tooltipEl;
}

export function showHoverTooltip(text){
	const el = ensureElement();
	el.textContent = text;
	el.style.display = "block";
	// ved cursoren, men holdt inden for viewporten (ellers klippes den, når cursoren er tæt på højre/nederste kant)
	const rect = el.getBoundingClientRect();
	const left = Math.min(lastX + 14, window.innerWidth - rect.width - 4);
	const top = Math.min(lastY + 14, window.innerHeight - rect.height - 4);
	el.style.left = Math.max(4, left) + "px";
	el.style.top = Math.max(4, top) + "px";
}

export function hideHoverTooltip(){
	if(tooltipEl) tooltipEl.style.display = "none";
}
